import React from 'react';
import PropTypes from 'prop-types';
import './traceabilities.scss';

const hasContent = (value: any) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '';
  return true;
};

const formatLongText = (value: any) => {
  if (!hasContent(value)) return '';
  if (typeof value !== 'string') {
    try {
      return JSON.stringify(value, null, 2);
    } catch (error) {
      return String(value);
    }
  }

  const trimmed = value.trim();
  if (!trimmed) return '';

  try {
    const parsed = JSON.parse(trimmed);
    return JSON.stringify(parsed, null, 2);
  } catch (error) {
    return trimmed;
  }
};

const SHORT_TEXT_LIMIT = 255;

const IForm = ({ selectedRow }: any) => {
  const topFields = [
    { label: 'Id', value: selectedRow?.id },
    { label: 'Task Id', value: selectedRow?.taskId },
    { label: 'Operation', value: selectedRow?.Operation },
    { label: 'Number', value: selectedRow?.Number },
    { label: 'Client Id', value: selectedRow?.ClientId },
    { label: 'WR Number', value: selectedRow?.WRNUMBER },
    { label: 'Created At', value: selectedRow?.createdAt },
  ].filter((item) => hasContent(item.value));

  const textEntries = [
    { label: 'Detail', value: formatLongText(selectedRow?.text1) },
    { label: 'Text 2', value: formatLongText(selectedRow?.text2) },
    { label: 'Text 3', value: formatLongText(selectedRow?.text3) },
    { label: 'Text 4', value: formatLongText(selectedRow?.text4) },
    { label: 'Additional Detail', value: formatLongText(selectedRow?.text5) },
  ].filter((item) => hasContent(item.value));

  const detailCards = textEntries.filter(
    (item) => item.value.length <= SHORT_TEXT_LIMIT,
  );

  const longBlocks = textEntries.filter(
    (item) => item.value.length > SHORT_TEXT_LIMIT,
  );

  return (
    <div className="traceability-detail">
      <div className="traceability-detail__header">
        <div>
          <p className="traceability-detail__eyebrow">Traceability detail</p>
          <h3 className="traceability-detail__title">
            {selectedRow?.text1 || selectedRow?.Operation || 'Traceability'}
          </h3>
        </div>
      </div>

      {topFields.length > 0 && (
        <section className="traceability-detail__section">
          <div className="traceability-detail__meta-grid">
            {topFields.map((field) => (
              <div key={field.label} className="traceability-detail__meta-card">
                <span className="traceability-detail__meta-label">{field.label}</span>
                <span className="traceability-detail__meta-value">{field.value}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {detailCards.length > 0 && (
        <section className="traceability-detail__section">
          <div className="traceability-detail__short-grid">
            {detailCards.map((field) => (
              <article key={field.label} className="traceability-detail__short-card">
                <span className="traceability-detail__meta-label">{field.label}</span>
                <p className="traceability-detail__short-text">{field.value}</p>
              </article>
            ))}
          </div>
        </section>
      )}

      {longBlocks.length > 0 && (
        <section className="traceability-detail__section traceability-detail__section--long">
          <div className="traceability-detail__long-grid">
            {longBlocks.map((field) => (
              <article key={field.label} className="traceability-detail__long-card">
                <div className="traceability-detail__long-head">
                  <span className="traceability-detail__meta-label">{field.label}</span>
                </div>
                <pre className="traceability-detail__code-block">{field.value}</pre>
              </article>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

IForm.propTypes = {
  selectedRow: PropTypes.shape({
    Number: PropTypes.string,
    Operation: PropTypes.string,
    taskId: PropTypes.string,
    id: PropTypes.number,
    ClientId: PropTypes.string,
    dateOfi: PropTypes.string,
    timeOfi: PropTypes.string,
    user: PropTypes.string,
    text1: PropTypes.string,
    text2: PropTypes.string,
    text3: PropTypes.string,
    text4: PropTypes.string,
    text5: PropTypes.string,
    WRNUMBER: PropTypes.string,
    createdAt: PropTypes.string,
  }),
};

export default IForm;
